import React, { useCallback } from 'react';

import { SearchFormProps, snackbar } from '@occc-app/design-system';
import { useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation } from '@occc/graphql';

import { TobaccoStoresSubmissionsTable } from '../tobacco-stores-submissions-table/tobacco-stores-submissions-table.component';
import { useRetailerNetworkScanDataTobaccoSiteSubmissions } from '../../../hooks/use-retailer-network-scan-data-tobacco-site-submissions.hook';
import { errorMessage } from '../../../retailer-connect.copies';
import { useRetailerConnectUser } from '../../../hooks/use-retailer-connect-user.hook';
import { toOCDate } from '../tobacco-submissions.utils';

type TobaccoStoresSubmissionsSearchValue = string | undefined;

export type TobaccoStoresSubmissionsTableContainerProps = {
  submittedAt: Date;
  retailerNetworkUuid: string;
};

export const TobaccoStoresSubmissionsTableContainer = ({
  submittedAt,
  retailerNetworkUuid,
}: TobaccoStoresSubmissionsTableContainerProps) => {
  const { userEmail } = useRetailerConnectUser();
  const [search, setSearch] = React.useState<TobaccoStoresSubmissionsSearchValue>();

  const { data, loading, error, paginationProps } =
    useRetailerNetworkScanDataTobaccoSiteSubmissions({
      filter: {
        retailerNetworkUuidEquals: retailerNetworkUuid,
        submittedAtEquals: submittedAt.toISOString(),
        search,
      },
    });

  const [sendReport, { loading: isDownloading }] =
    useEmailRetailerNetworkScanDataTobaccoSiteSubmissionsCsvReportMutation({
      onCompleted: () => {
        snackbar.success(`A download link has been sent to ${userEmail}.`);
      },
      onError: () => {
        snackbar.error(errorMessage);
      },
    });

  const onDownloadCsvClick = useCallback(() => {
    if (!userEmail) {
      return;
    }
    void sendReport({
      variables: {
        emailToSendReport: userEmail,
        filter: {
          retailerNetworkUuidEquals: retailerNetworkUuid,
          submittedAtEquals: toOCDate(submittedAt),
          search,
        },
      },
    });
  }, [retailerNetworkUuid, search, sendReport, submittedAt, userEmail]);

  const onSearchSubmit = useCallback<SearchFormProps['onSubmit']>(({ search }) => {
    setSearch(search);
  }, []);

  return (
    <TobaccoStoresSubmissionsTable
      data={data}
      submittedAt={submittedAt}
      isDownloading={isDownloading}
      onDownloadCsvClick={onDownloadCsvClick}
      onSearchSubmit={onSearchSubmit}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};
